/* eslint-disable no-case-declarations */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import metadata from './MLHOExcludedAnimalLiabilitiesComponent.metadata.json5';
import './MLHOExcludedAnimalLiabilitiesComponent.messages';

import React from 'react';

// Component is always non editable even in custom quote
function MLHOExcludedAnimalLiabilitiesComponent(props) {
    const {
        items,
        readOnly
    } = props;

    const overrides = {
        stackTableDiv: {
            className: readOnly ? 'stack-table' : 'stack-table plain'
        },
        tableRowIterable: {
            data: items
        }
    };


    const resolvers = {};

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLHOExcludedAnimalLiabilitiesComponent.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})),
    readOnly: PropTypes.bool
};

export default MLHOExcludedAnimalLiabilitiesComponent;
